import React from 'react';
import { LinkButton } from '@cian/ui-kit';
import { useOfferContext } from '../../../../context';

export function AgentShowMoreOffersContainer() {
  const { agentOffersLink } = useOfferContext();

  if (!agentOffersLink) {
    return null;
  }

  return (
    <LinkButton
      size="XS"
      theme="fill_secondary"
      target="_blank"
      href={agentOffersLink}
      onClick={e => e.stopPropagation()}
    >
      Ещё объекты
    </LinkButton>
  );
}
